/* ==================================================
  カートページの整合処理

  1. ノベルティの表示ズレ補正
  2. 空カート時の gift_wrapping 属性リセット
===================================================*/

/* ------------------------------
  ノベルティの表示ズレ補正

  ノベルティは外部アプリ（RuffRuff Order Bonus）がカート追加の 1〜2 秒後にギフトを
  追加するため、追加直後にカートページへ遷移すると、サーバー描画が間に合わず
  ギフトが明細に表示されないことがある（カートのデータには入っている）。
  ギフトがカートにあるのに未描画なら、1 回だけリロードして再描画させる。
------------------------------*/
(() => {
  'use strict';

  const FLAG = 'c_cart_gift_reloaded';
  const GIFT_ITEM_TYPE = 'gift';
  const ROW_SELECTOR = '.line-item-table__list .line-item';
  const POLL_INTERVAL = 500;
  const POLL_MAX = 6; /* 約3秒までギフト反映を待つ */

  const sleep = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

  function renderedRowCount() {
    return document.querySelectorAll(ROW_SELECTOR).length;
  }

  async function reconcile() {
    /*  直前にこのスクリプトでリロードした直後なら、二重リロードしない  */
    if (sessionStorage.getItem(FLAG)) {
      sessionStorage.removeItem(FLAG);
      return;
    }

    for (let i = 0; i < POLL_MAX; i += 1) {
      let cart;
      try {
        cart = await fetch('/cart.js').then((response) => response.json());
      } catch (error) {
        return;
      }

      const hasGift = (cart.items || []).some(
        (item) => item.properties && item.properties._ItemType === GIFT_ITEM_TYPE
      );
      const rendered = renderedRowCount();

      if (hasGift && rendered > 0 && rendered < cart.items.length) {
        /*  ギフトはカートにあるが未描画 → 1 回だけリロード  */
        sessionStorage.setItem(FLAG, '1');
        window.location.reload();
        return;
      }

      if (hasGift && rendered >= cart.items.length) {
        /*  すでに正しく描画されている  */
        return;
      }

      await sleep(POLL_INTERVAL);
    }
  }

  if (document.readyState !== 'loading') {
    reconcile();
  } else {
    document.addEventListener('DOMContentLoaded', reconcile);
  }
})();

/* ------------------------------
  空カート時のギフト情報リセット

  gift_wrapping 属性と備考欄（cart.note）は、カートを空にしても Shopify 側に残る。
  属性を 'no' へ戻す処理は c_cart-gift-wrapping.js が持っているが、
  空カートではギフトブロックごと描画されないため起動しない。
  結果 'yes' と前回の指示文が残り、次に商品を追加してカートページを経由せずに
  決済すると、ラッピングが無いのに「ラッピング希望」の注文になる。

  カートに商品がある間は c_cart-gift-wrapping.js が属性の担当なので触らない。
  空カートでのみ動かすことで、同じ属性への二重書き込みが起きない
------------------------------*/
(() => {
  'use strict';

  /*  リセットが必要かどうかは Liquid が判定済み。無ければ何もしない  */
  if (!document.querySelector('[data-gift-empty-reset]')) return;

  fetch('/cart/update.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ attributes: { gift_wrapping: 'no' }, note: '' })
  }).catch((error) => {
    console.error('[c_cart-gift-reconcile]', 'reset failed', error);
  });
})();
